import service from '@/utils/request';

//分页获取FormConfig列表
export var getList = function getList(params) {
  return service({
    url: "/formConfig/getList",
    method: 'get',
    params: params
  });
};

//用id查询FormConfig
export var getListByID = function getListByID(params) {
  return service({
    url: "/formConfig/first",
    method: 'get',
    params: params
  });
};

//创建FormConfig
export var create = function create(data) {
  return service({
    url: "/formConfig/create",
    method: 'post',
    data: data
  });
};

//更新FormConfig
export var update = function update(data) {
  return service({
    url: "/formConfig/update",
    method: 'put',
    data: data
  });
};

//删除FormConfig
export var deleteByID = function deleteByID(data) {
  return service({
    url: "/formConfig/delete",
    method: 'delete',
    data: data
  });
};

//api接口
export var apiRequest = function apiRequest(data) {
  return service({
    url: "/formConfig/apiRequest",
    method: 'post',
    data: data
  });
};

//cpInfo
export var cpInfo = function cpInfo(data) {
  return service({
    url: "/config/cpInfo",
    method: 'get',
    data: data
  });
};

//共用配置
export var commonConfig = function commonConfig(data) {
  return service({
    url: "/config/commonConfig",
    method: 'post',
    data: data
  });
};
export var eventConfigAll = function eventConfigAll(data) {
  return service({
    url: "/config/eventConfigAll",
    method: 'post',
    data: data
  });
};
export var eventConfig = function eventConfig(data) {
  return service({
    url: "/config/eventConfig",
    method: 'post',
    data: data
  });
};
export var adPositionConfigAll = function adPositionConfigAll(data) {
  return service({
    url: "/config/adPositionConfigAll",
    method: 'post',
    data: data
  });
};
export var adPositionConfig = function adPositionConfig(data) {
  return service({
    url: "/config/adPositionConfig",
    method: 'post',
    data: data
  });
};
export var gameplayTypeConfig = function gameplayTypeConfig(data) {
  return service({
    url: "/config/gameplayTypeConfig",
    method: 'post',
    data: data
  });
};
export var gameplayTypeConfigAll = function gameplayTypeConfigAll(data) {
  return service({
    url: "/config/gameplayTypeConfigAll",
    method: 'post',
    data: data
  });
};